import { useEffect, useState } from 'react';
import MainHeading from './MainHeading';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { callApi } from '@/api/callApi';
import useFilter from '@/hooks/useFilter';
import NoRecordIcon from '../Icons/NoRecordIcon';
import PaginationComponent from './PaginationComponent';
// import { IDeleteResponse } from '@/interfaces/common.model';
import moment from 'moment';
import { IPageInfo } from '@/interfaces/common.model';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
interface ILogResponse {
  status: boolean;
  data: {
    pageInfo: IPageInfo;
    logs: [];
  };
}
interface ILogData {
  text: string;
  createdAt: string;
}
interface ILogsProps {
  type: string;
  id: string;
  refreshLogs: boolean;
  setRefreshLogs?: (value: boolean) => void;
}
interface ILogPageState extends IPageInfo {
  count: number;
  tableLoader: boolean;
  logsData: ILogData[];
}
const Logs = ({ type, id, refreshLogs, setRefreshLogs }: ILogsProps) => {
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [pageStates, setPageStates] = useState<ILogPageState>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    logsData: [],
  });

  const getLogsData = async () => {
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));

    try {
      const response: ILogResponse = await callApi(
        `${API_URL + API_ENDPOINT.getLogs}?pageNumber=${pageStates?.currentPage}&pageSize=${filterDetails?.pageSize}&type=${type}&id=${id}`,
        { method: 'GET' },
      );

      if (setRefreshLogs) {
        setRefreshLogs(false);
      }
      console.log(response);

      if (response?.status) {
        setPageStates((pre) => ({
          ...pre,
          logsData: response?.data?.logs || [],
          totalPages: response?.data?.pageInfo?.totalPages,
          count: response?.data?.pageInfo?.total ?? 0,
        }));
      } else {
        setPageStates((pre) => ({
          ...pre,
          logsData: [],
        }));
      }
    } catch (error) {
      console.error('Log fetch error:', error);
      setPageStates((pre) => ({
        ...pre,
        logsData: [],
      }));
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  };

  useEffect(() => {
    getLogsData();
  }, [pageStates?.currentPage, refreshLogs]);

  const { pageChangeHandler } = useFilter(pageStates, setPageStates);
  return (
    <div className="content">
      <MainHeading title={'Logs'} />
      <div className="card">
        <div className="card-body">
          <div className={pageStates?.tableLoader ? 'loading-skeleton' : ''}>
            {pageStates?.tableLoader ? (
              <>
                {[1].map((_, index) => (
                  <div
                    key={`skeleton-${index}`}
                    className="card mb-3 shadow-sm border-light"
                  >
                    <div className="card-body">
                      <div
                        className="skeleton-placeholder"
                        style={{ height: '60px', width: '100%' }}
                      >
                        ....
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : pageStates?.logsData?.length > 0 ? (
              pageStates.logsData.map((log, index) => (
                <div key={index} className="card mb-3 shadow-sm border-light">
                  <div className="card-body">
                    <h5 className="card-title fw-bold mb-2">{log?.text}</h5>
                    <p className="card-text text-muted mb-0 fs-5">
                      {moment(log?.createdAt).format('DD MMM YYYY, hh:mm A')}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-muted py-4">
                <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                  <NoRecordIcon />
                  <span>No Logs Available</span>
                </div>
              </div>
            )}
          </div>

          <PaginationComponent
            pageSize={filterDetails?.pageSize}
            currentPage={pageStates?.currentPage}
            pageChangeHandler={pageChangeHandler}
            totalPages={pageStates?.totalPages}
          />
        </div>
      </div>
    </div>
  );
};
export default Logs;
